import {Injectable} from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {AuthService} from 'app/core/auth/auth.service';
import {Router} from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    /**
     * Constructor
     */
    constructor(private readonly _authService: AuthService, private readonly _router: Router) {
    }

    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Clone the request object
        let newReq = req.clone();
        const refresh = localStorage.getItem('refresh');
        // Request
        //
        // If the access token didn't expire, add the Authorization header.
        // We won't add the Authorization header if the access token expired.
        // This will force the server to return a "401 Unauthorized" response
        // for the protected API routes which our response interceptor will
        // catch and delete the access token from the local storage while logging
        // && !AuthUtils.isTokenExpired(this._authService.accessToken)
        // the user out from the app.
        try {
            if (this._authService.accessToken) {
                if (refresh === null) {
                    this._authService.refreshToken().then((user) => {
                        // @ts-ignore
                        if (user) this._authService.accessToken = user.toJSON().stsTokenManager.accessToken;
                    });
                }
                newReq = req.clone({
                    headers: req.headers.set('Taxsat-Authorization', 'Bearer ' + this._authService.accessToken)
                });
            }
        } catch (error) {
            console.error(error);
            this._authService.signOut();
            this._router.navigateByUrl('/sign-in');
        }

        // Response
        return next.handle(newReq).pipe(
            catchError((error: any): Observable<never> => {

                // Catch "401 Unauthorized" responses
                if (error instanceof HttpErrorResponse && error.status === 401) {
                    this._authService.signOut();
                    this._router.navigateByUrl('/sign-in');
                }

                return throwError((): any => error);
            })
        );
    }
}
